import Gawd from "web/lib/gawd"
import useWalletTokens from "./useWalletTokens"

export default function useIsGawdOwner(gawd: Gawd) {
  const ownedTokens = useWalletTokens()
  return ownedTokens.map((t) => t.id).includes(gawd.id())

}